import React from 'react';
import PageLoadingMask from 'components/masks/PageLoadingMask';
import { useSeenModulePixel } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { PERSONAL_LOAN_VERTICAL } from 'types/marketplaceTiles.constants';
import { PL_LOW_SCORE } from 'types/morph.pagePosition.constants';
import PersonalLoanLowScoreModuleView from './PersonalLoanLowScoreModuleView';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { redirectPersonalLoanOfferWithStaticModule } from 'actions/offers.actions';

const PersonalLoanLowScoreModuleController = props => {
  const { eventHandler, globalLoadingFlag, dispatch, history } = props;

  const trackingAtr = getViewModuleTrackingAttributes({
    pagePosition: PL_LOW_SCORE,
    modulePosition: props.modulePosition,
    vertical: PERSONAL_LOAN_VERTICAL,
  });

  const loading = globalLoadingFlag;

  const seenModuleTracking = useSeenModulePixel(trackingAtr);

  const onClickPrequal = () => {
    eventHandler(CLICK, {
      'Click Type': 'See If I’m Pre-Qualified',
      Vertical: PERSONAL_LOAN_VERTICAL,
      'Module Name': PL_LOW_SCORE,
    });
    dispatch(
      redirectPersonalLoanOfferWithStaticModule(history, 'PREQUAL_FUNNEL'),
    );
  };

  if (loading) {
    return <PageLoadingMask />;
  } else {
    return (
      <>
        {seenModuleTracking}
        <PersonalLoanLowScoreModuleView
          {...props}
          onClickPrequal={onClickPrequal}
        />
      </>
    );
  }
};

export default PersonalLoanLowScoreModuleController;
